/* global $ */

import toArray from '../helpers/toArray';

const $body = $('body');

const relatedProductSubmit = {
  initialize() {
    $body.on('submit', '.js-related-product-add', (event) => {
      event.preventDefault();

      const target = event.currentTarget;

      const reloadOnSubmit = target.hasAttribute('data-reload-on-submit') || false;
      const productItemObj = JSON.parse(target.dataset.gtmArray);

      // Show the delete button after cart addition...
      this.toggleCartButtons(this.productForTarget(event.currentTarget), 'delete');

      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          event: 'addToCart',
          currency: 'EUR',
          value: (productItemObj.price * productItemObj.quantity).toFixed(2),
          items: [
            productItemObj,
          ],
        });
      }

      this.submitProductToCart(event.currentTarget, 1)
        .then(() => {
          if (reloadOnSubmit) {
            window.location.reload();
          }
        })
        .catch(() => {
          // On error, show the add button again...
          this.toggleCartButtons(this.productForTarget(event.currentTarget), 'add');
        });
    });

    $body.on('submit', '.js-related-product-delete', (event) => {
      event.preventDefault();

      // Show the add button after deletion...
      this.toggleCartButtons(this.productForTarget(event.currentTarget), 'add');

      this.submitProductToCart(event.currentTarget, 0)
        .catch(() => {
          // On error, show the delete button again...
          this.toggleCartButtons(this.productForTarget(event.currentTarget), 'remove');
        });
    });
  },

  submitProductToCart(form) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: $(form).attr('action'),
        type: $(form).attr('method'),
        data: $(form).serialize(),
        dataType: 'json',
        success: res => resolve(res),
        error: err => reject(err),
      });
    })
      .then((res) => {
        const itemsCount = res.items_count;

        this.outputCount(itemsCount);

        return res;
      })
      .catch((err) => {
        if (typeof window.Sentry !== 'undefined') {
          window.Sentry.captureException(err);
        }

        throw err;
      });
  },

  outputCount(count) {
    if (Number.isNaN(parseInt(count, 10))) {
      return;
    }

    const output = toArray(document.querySelectorAll('.js-navigation-cart-item-count'));

    output.forEach((element) => {
      element.innerText = count;
    });
  },

  productForTarget(target) {
    return $(target).parents('.js-product');
  },

  toggleCartButtons($product, cartButtonType = 'add') {
    $product.find('.js-related-product-add').toggle(cartButtonType === 'add');
    $product.find('.js-related-product-delete').toggle(cartButtonType !== 'add');
  },
};

export default relatedProductSubmit;
